import { extend } from 'flarum/common/extend';
import Modal from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';

/**
 * 修改 Modal 标题文案
 * 可以在这里自定义要修改的标题文本
 */
export default function modifyModalTitle() {
  // 定义标题映射表（原始标题 -> 新标题）
  const titleMap = {
    'Choose Tags': 'Select the group you want to post in',
    'Choose a primary tag': 'Select the group you want to post in',
    // 可以添加更多标题映射
    // 'Log In': '登录',
    // 'Sign Up': '注册',
  };
  
  // 根据 Modal 类名修改标题的映射表
  const classNameMap = {
    'TagSelectionModal': 'Select the group you want to post in',
    'TagDiscussionModal': 'Select the group you want to post in',
    // 可以添加更多类名映射
  };
  
  // 定义 placeholder 映射表（原始 placeholder -> 新 placeholder）
  const placeholderMap = {
    'Choose a primary tag': 'Select the group you want to post in',
    'Choose 1 primary tag': 'Select the group you want to post in',
    'Choose primary tags': 'Select the group you want to post in',
    // 可以添加更多 placeholder 映射
  };
  
  // 修改标题的通用函数
  const updateTitle = (modal) => {
    const titleElement = modal.$('.App-titleControl');
    if (titleElement && titleElement.length) {
      const originalTitle = titleElement.text().trim();
      const modalClassName = modal.className();
      
      // 优先根据类名修改
      for (const [className, newTitle] of Object.entries(classNameMap)) {
        if (modalClassName.includes(className)) {
          titleElement.text(newTitle);
          return;
        }
      }
      
      // 其次根据原始标题修改
      if (titleMap[originalTitle]) {
        titleElement.text(titleMap[originalTitle]);
      }
    }
  };
  
  // 修改 placeholder 的通用函数
  const updatePlaceholder = (modal) => {
    // 查找 TagSelectionModal-form 内的 input 元素
    const inputElement = modal.$('.TagSelectionModal-form input');
    if (inputElement && inputElement.length) {
      const originalPlaceholder = inputElement.attr('placeholder') || '';
      
      // 根据原始 placeholder 修改
      for (const [original, newPlaceholder] of Object.entries(placeholderMap)) {
        if (originalPlaceholder.includes(original)) {
          inputElement.attr('placeholder', newPlaceholder);
          return;
        }
      }
      
      // 如果是 TagSelectionModal，直接设置默认 placeholder
      const modalClassName = modal.className();
      if (modalClassName.includes('TagSelectionModal') || modalClassName.includes('TagDiscussionModal')) {
        if (originalPlaceholder && !placeholderMap[originalPlaceholder]) {
          // 如果 placeholder 包含 "primary tag" 相关文本，替换为自定义文本
          if (originalPlaceholder.toLowerCase().includes('primary tag') || 
              originalPlaceholder.toLowerCase().includes('choose')) {
            inputElement.attr('placeholder', 'Select the group you want to post in');
          }
        }
      }
    }
  };
  
  // 使用 MutationObserver 监听 placeholder 变化
  const setupPlaceholderObserver = (modal) => {
    const inputElement = modal.$('.TagSelectionModal-form input');
    if (inputElement && inputElement.length) {
      // 如果已经设置了 observer，先断开
      if (inputElement.data('placeholder-observer')) {
        inputElement.data('placeholder-observer').disconnect();
      }
      
      // 创建 MutationObserver 监听属性变化
      const observer = new MutationObserver(() => {
        updatePlaceholder(modal);
      });
      
      // 开始观察 input 元素的属性变化
      observer.observe(inputElement[0], {
        attributes: true,
        attributeFilter: ['placeholder']
      });
      
      // 保存 observer 引用，以便后续清理
      inputElement.data('placeholder-observer', observer);
    }
  };
  
  // 监听 Modal 显示事件
  extend(Modal.prototype, 'oncreate', function () {
    // 延迟执行，确保 DOM 已渲染
    setTimeout(() => {
      updateTitle(this);
      updatePlaceholder(this);
      setupPlaceholderObserver(this);
    }, 0);
  });
  
  // 监听 Modal 更新事件（当 Modal 内容变化时）
  extend(Modal.prototype, 'onupdate', function () {
    setTimeout(() => {
      updateTitle(this);
      updatePlaceholder(this);
      setupPlaceholderObserver(this);
    }, 0);
  });
  
  // 清理 observer 当 Modal 销毁时
  extend(Modal.prototype, 'onremove', function () {
    const inputElement = this.$('.TagSelectionModal-form input');
    if (inputElement && inputElement.length) {
      const observer = inputElement.data('placeholder-observer');
      if (observer) {
        observer.disconnect();
        inputElement.removeData('placeholder-observer');
      }
    }
  });
}

